export default [
    {
        label: "get",
        value: "get",
    },
    {
        label: "post",
        value: "post",
    },
    {
        label: "put",
        value: "put",
    }
]